module.exports = __webpack_public_path__ + "static/media/logo.46cdbdf3.svg";